import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { StartCasePipe } from '@ng-cloud/badger-core/common/pipes/start-case.pipe';
import * as _ from 'lodash';
import { MapLayer } from '../groupings/map-layer';
import { MapComponent } from '../map.component';

@Component({
  selector: 'bt-map-visibility-controls',
  templateUrl: './map-visibility-controls.component.html',
  styleUrls: ['./map-visibility-controls.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatCard,
    MatCheckbox,
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatTooltip,
    StartCasePipe
  ]
})
export class MapVisibilityControlsComponent implements OnInit {
  @Input('map') mapComponent: MapComponent;
  layers: MapLayer[] = [];

  ngOnInit() {
    this.getLayers();
  }

  getLayers() {
    this.layers = this.mapComponent
      .getLayers()
      .sort((a, b) => b.zIndex - a.zIndex);
  }

  toggleLayer(layer: string) {
    this.mapComponent.toggleLayer(layer);
  }

  enabledLayers(): MapLayer[] {
    return _.filter(this.layers, (layer) => layer.enabled === true);
  }
}
